import api from "../../../config/gatewayConfig";
import { httpClient, silentPollingConfig } from "../../httpClient";

export const apiNotificationsProvider = {
  list: async (payload, { silent = false } = {}) => {
    return httpClient.post(api.vendorNotificationsList, payload, {
      headers: { "Content-Type": "application/json" },
      ...(silent ? silentPollingConfig : {}),
    });
  },
  state: async (payload) => {
    return httpClient.post(api.vendorNotificationsState, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },
};
